import './index.scss'
import '../../assets/scripts/countNumber.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

!(function(){
  numScroll ()
})()
//数字滚动效果
function numScroll () {
  let num1 = $("#scrollNum1").html()
  let num2 = $("#scrollNum2").html()
  let num3 = $("#scrollNum3").html()
  let num4 = $("#scrollNum4").html()
  $("#scrollNum1").rollNum({
      deVal: num1
  });
  $("#scrollNum2").rollNum({
      deVal: num2
  });
  $("#scrollNum3").rollNum({
      deVal: num3
  });
  $("#scrollNum4").rollNum({
      deVal: num4
  });
}